import React, { useState, useEffect } from 'react';

function Loader() {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setWidth(prevWidth => {
                let value = prevWidth + 5;
                if (value > 105) {
                    return 5;
                } else {
                    return value;
                }
            });
        }, 50);

        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ width: `${width}%` }} className="h-1 transition-all delay-0 ease-linear bg-[#36d7b7]"></div>
    );
}

export default Loader;
